/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Hero from "../../../components/hero/Hero";
import "./create-doctor.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { createDoctor } from "../../../redux/apiCalls/doctorsApiCalls";
import { Rings } from "react-loader-spinner";
import { fetchAllDepartments } from "../../../redux/apiCalls/departmentApiCalls";
import { fetchAllCities } from "../../../redux/apiCalls/cityApiCalls";
import Form from "react-bootstrap/Form";

const CreateDoctor = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading, isDoctorCreated } = useSelector((state) => state.doctor);
  const departments = useSelector((state) => state.department.departments);
  const cities = useSelector((state) => state.city.cities);

  const [name, setName] = useState("");
  const [title, setTitle] = useState("");
  const [department, setDepartment] = useState("");
  const [description, setDescription] = useState("");
  const [address, setAddress] = useState("");
  const [mobile, setMobile] = useState("");
  const [tell, setTell] = useState("");
  const [registrationType, setRegistrationType] = useState("");
  const [workingDay, setWorkingDay] = useState("");
  const [city, setCity] = useState("");

  //Form submit handler
  const createformSubmitHandler = (e) => {
    e.preventDefault();
    if (name.trim() === "") {
      return toast.error("يجب ادخال الاسم");
    }
    if (title.trim() === "") {
      return toast.error("يجب ادخال المؤهل");
    }
    if (address.trim() === "") {
      return toast.error("يجب ادخال العنوان");
    }
    if (mobile.trim() === "") {
      return toast.error("يجب ادخال رقم الموبيل");
    }
    if (tell.trim() === "") {
      return toast.error("يجب ادخال رقم الهاتف");
    }
    if (workingDay.trim() === "") {
      return toast.error("يجب ادخال ايام العمل");
    }
    if (department.trim() === "") {
      return toast.error("يجب ادخال القسم");
    }
    if (registrationType.trim() === "") {
      return toast.error("يجب ادخال طريقة الحجز");
    }
    if (city.trim() === "") {
      return toast.error("يجب ادخال المدينة");
    }
    if (description.trim() === "") {
      return toast.error("يجب ادخال معلومات عن الطبيب");
    }

    dispatch(
      createDoctor({
        name,
        title,
        address,
        mobile,
        tell,
        workingDay,
        department,
        registrationType,
        city,
        description,
      })
    );
  };

  useEffect(() => {
    if (isDoctorCreated) {
      navigate("/");
    }
  }, [isDoctorCreated, navigate]);

  useEffect(() => {
    dispatch(fetchAllDepartments());
    dispatch(fetchAllCities());
  }, []);

  return (
    <div className="create-doctor-page">
      <Hero pageTitle="" pageDiscription="" />

      <form
        onSubmit={createformSubmitHandler}
        className="create-doctor-page-form"
      >
        <div className="create-doctor-page-form-row-color"></div>
        <h4>اضافة بيانات طبيب</h4>
        <div className="create-doctor-page-form-row">
          <input
            type="text"
            placeholder="اسم الطبيب"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <input
            type="text"
            placeholder="المؤهل "
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <input
            type="text"
            placeholder="العنوان "
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
        </div>

        <div className="create-doctor-page-form-row">
          <input
            type="text"
            placeholder=" الموبيل"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
          />
          <input
            type="text"
            placeholder=" التليفون"
            value={tell}
            onChange={(e) => setTell(e.target.value)}
          />
          <input
            type="text"
            placeholder=" ايام العمل"
            value={workingDay}
            onChange={(e) => setWorkingDay(e.target.value)}
          />
        </div>

        <div className="create-doctor-page-form-row">
          <input
            type="text"
            placeholder="كيفية الحجز"
            value={registrationType}
            onChange={(e) => setRegistrationType(e.target.value)}
          />
          <Form.Select
            onChange={(e) => setDepartment(e.target.value)}
            aria-label="التخصص"
          >
            <option disabled>التخصص</option>
            {departments?.map((dep) => (
              <option key={dep?._id} value={dep?.title}>
                {dep?.title}
              </option>
            ))}
          </Form.Select>

          <Form.Select
            onChange={(e) => setCity(e.target.value)}
            aria-label="المدينة"
          >
            <option disabled>المدينة</option>
            {cities?.map((city) => (
              <option value={city?.cityName} key={city._id}>
                {city?.cityName}
              </option>
            ))}
          </Form.Select>
        </div>
        <div className="create-doctor-page-form-row">
          <textarea
            onChange={(e) => setDescription(e.target.value)}
            value={description}
            rows="5"
            placeholder=" عن الطبيب"
          ></textarea>
        </div>

        {/* <div className="create-doctor-page-form-row">
          <input
            type="file"
            placeholder="صورة الطبيب"
            onChange={(e) => setFile(e.target.files[0])}
          />
        </div> */}

        <div className="create-doctor-page-form-row">
          <button type="submit" className="create-doctor-page-btn">
            {loading ? (
              <Rings
                className="ring-spinner"
                height="50"
                width="50"
                color="#fff"
                radius="6"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel="rings-loading"
              />
            ) : (
              "إضافة"
            )}
          </button>
        </div>
        <div className="create-doctor-page-form-row-color-end"></div>
      </form>
    </div>
  );
};

export default CreateDoctor;
